import React, { useState, useEffect } from 'react'
import useQuery from '../../../shared/functions/functions';
import PasswordResetTokenNotValid from '../../components/reset-password/token-not-valid';
import ResetPasswordForm from '../../components/reset-password/reset';
import axios from '../../../config/axios/axios';
import { Redirect } from 'react-router-dom';

function ResetPasswordBusiness() {

    const query = useQuery();
    const verificationToken = query.get("verificationToken");
    const [token] = useState(verificationToken);
    const [tokenExpired, setVerificationTokenExpired] = useState(false);

    useEffect(() => {
        validateToken(token);
    }, [])

    if (!token) {
        return (
            <div>
                <ResetPasswordForm type={'business'} token={token} />
                {/* <Redirect to={"/page-not-found"} /> */}
            </div>
        )
    }

    // if (tokenExpired) {
    //     return (
    //         <PasswordResetTokenNotValid />
    //     )
    // }

    return (
        <div>
            <ResetPasswordForm type={'business'} token={token} />
        </div>
    )

    function validateToken(token) {
        axios.get(`client/business/reset-password`, { params: { token: token } })
            .then(response => {
                if (response.data === true) {
                    setVerificationTokenExpired(false);
                } else {
                    setVerificationTokenExpired(true);
                }
            }
            )
            .catch((error) => { setVerificationTokenExpired(true) });
    }
}

export default ResetPasswordBusiness
